import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import styles from './Textarea.module.scss'

export const Textarea = React.forwardRef(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isReadOnly = false,
      isRequired = false,
    },
    ref,
  ) => (
    <textarea
      className={cx(styles.textarea, {
        [fieldClassName]: Boolean(fieldClassName),
        [styles.invalid]: Boolean(error),
      })}
      disabled={isDisabled}
      readOnly={isReadOnly}
      required={isRequired}
      {...{ id, name, placeholder, ref, value, onBlur, onChange }}
    />
  ),
)

export const ControlledTextarea = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  placeholder,
  isDisabled,
  isReadOnly,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Textarea
        {...{
          error,
          fieldClassName,
          id,
          name,
          placeholder,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isReadOnly,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
